/** Component for Models Functionalities

  //Testing Dynamic import of component relies on /snippets/theme-options.liquid to expose assets url
  (async () => {
      const { default:media } = await import(theme.components.mediaURL);
        media.showConsole();
  })();
 */
var models = {
  instModelsViewerCarousel: null,
  instMainProductZoom: null,
  init: function () {
    $(document).on("change", ".model-viewer .model-input-view", function (e) {
      if ($(this).prop("checked")) {
        models.saveModelView("1");
      } else {
        models.saveModelView("0");
      }
      models.updateModelControls();
    });

    $(document).on("click", ".model-viewer .model-change", function (e) {
      e.preventDefault();

      var getModelId = models.getModel();

      if (getModelId == "0" || getModelId == "") {
        return false;
      } else {
        if ($(this).hasClass("hidemodellist")) {
          $(this).removeClass("hidemodellist").addClass("showmodellist");
          $(".model-viewer-selection").removeClass("hide");
          //We hide any element on the page with the attribute data-model-hide
          //see collection-filters.liquid
          $("div[data-model-hide='true']").addClass("hide");

          if (models.instModelsViewerCarousel == null) {
            (async () => {
              const { carousel } = await import(theme.components.commonURL);
              models.instModelsViewerCarousel = new carousel();
              models.instModelsViewerCarousel.init(".model-viewer-selection");
            })();
          }
        } else {
          $(this).removeClass("showmodellist").addClass("hidemodellist");
          $(".model-viewer-selection").addClass("hide");
        }
      }
    });

    $(document).on("click", ".model-viewer-selection .model", function (e) {
      e.preventDefault();
      var getDataModelID = $(this).attr("data-model-id");
      models.saveModel(getDataModelID);
      models.setSelectedModel();

      models.displaySelectedModelInfo();

      $(".model-viewer-selection").addClass("hide");
      $(".model-viewer .model-change")
        .removeClass("showmodellist")
        .addClass("hidemodellist");
      $(".model-viewer .model-select").addClass("hide");
      $(".model-viewer .model-selected").removeClass("hide");
      models.updateModelsDisplay(".product-media");
    });

    $(document).on("click", "#closemobileviewer", function (e) {
      e.preventDefault();
      models.closeMobileViewer();
    });

    models.repositionModels();
    models.setSelectedModel();

    var getModelView = models.getModelView();
    $(".model-viewer .model-input-view").prop(
      "checked",
      getModelView == "1" ? true : false
    );

    models.updateModelControls();
  },
  updateModelControls: function () {
    var getModelView = models.getModelView();
    var getModelId = models.getModel();

    $(".model-viewer .model-selected-name").html("");
    $(".model-viewer .model-selected-info").html("").addClass("hide");
    $(".model-viewer .model-selected-heading").addClass("hide");
    $(".model-viewer .model-selected").addClass("hide");

    if (getModelView == "1") {
      $(".model-viewer .model-change").removeClass("hide");

      if (getModelId == "0" || getModelId == "") {
        $(".model-viewer .model-select").removeClass("hide");
        $(".model-viewer-selection").removeClass("hide");
      } else {
        $(".model-viewer-selection").addClass("hide");
        $(".model-viewer .model-change")
          .removeClass("showmodellist")
          .addClass("hidemodellist");
        $(".model-viewer .model-select").addClass("hide");
        $(".model-viewer .model-selected").removeClass("hide");
        models.displaySelectedModelInfo();
      }
    } else {
      $(".model-viewer .model-change").addClass("hide");
      $(".model-viewer .model-select").addClass("hide");
      $(".model-viewer-selection").addClass("hide");
    }
    models.updateModelsDisplay(".product-media");
  },
  repositionModels: function () {
    //leveraging JS code to reorder models instead of using liquid
    for (var i = 1; i <= 5; i++) {
      var getModelPositionElement = $(
        ".model-viewer-selection a.model[data-model-position='" + i + "']"
      );

      if (getModelPositionElement.length > 0) {
        getModelPositionElement
          .parent()
          .appendTo($(".model-viewer .models-list-wrap"));
      }
    }
  },

  displaySelectedModelInfo: function () {
    $(".model-viewer .model-selected-name").html(models.getModelInfo().name);
    $(".model-viewer .model-selected-info")
      .html(models.getModelInfo().description)
      .removeClass("hide");
    $(".model-viewer .model-selected-heading").removeClass("hide");
  },

  updateQuickViewModelsDisplay: function () {
    var getModelId = this.getModel();
    var getModelView = models.getModelView();

    if (getModelView == "") {
      getModelId = "0";
    }

    if (getModelId !== "") {
      models.updateModelsDisplay(
        "#quickview-product-template .product-media",
        getModelId
      );
    }
  },
  updateModelsDisplay: function (elems) {
    var getModelId = this.getModel();
    var getModelView = models.getModelView();

    if (getModelView == "" || getModelView == "0") {
      getModelId = "0";
    }

    //console.log(elems)
    $(elems).each(function (ind) {
      var jsonModels = $(this).attr("data-models");
      var isMain = false;

      var hasVideo = false;
      var videoRef = $(this).attr("data-video");

      if ($(this).hasClass("main")) {
        var iWidth = "646";
        var iHeight = "702";
        isMain = true;
      } else {
        //card
        var iWidth = "374";
        var iHeight = "415";
      }

      if ($(this).hasClass("hasVideo")) {
        hasVideo = true;
      }

      if (jsonModels !== "") {
        jsonModels = JSON.parse(jsonModels);

        var getViews = jsonModels[0].views; //default views

        for (var i = 0; i < jsonModels.length; i++) {
          if (jsonModels[i].id == getModelId) {
            getViews = jsonModels[i].views;
            break;
          }
        }

        //Update Image pointers
        var pager = "";
        var htmlSliders = "";
        for (var j = 0; j < getViews.length; j++) {
          htmlSliders += "<div class='media-slide'>";
          if (j == 0) {
            htmlSliders +=
              "<img " +
              (isMain ? " " : "loading='lazy' ") +
              "width='" +
              iWidth +
              "' height='" +
              iHeight +
              "' src='" +
              getViews[j] +
              "&width=" +
              iWidth;
          } else {
            htmlSliders +=
              "<img loading='lazy' width='" +
              iWidth +
              "' height='" +
              iHeight +
              "' src='data:image/gif;base64,R0lGODlhAQABAAAAACH5BAEKAAEALAAAAAABAAEAAAICTAEAOw==' data-src='" +
              getViews[j] +
              "&width=" +
              iWidth;
          }

          htmlSliders += "'";
          if (isMain) {
            //add additional properties for zoom functionality on Main Image Only
            htmlSliders += " class='nszoomer' ";
            htmlSliders += " preloader='" + theme.loaderImage + "' ";
            htmlSliders += " big='" + getViews[j] + "&width=1200" + "' ";
            htmlSliders += " placeholder='" + theme.components.spacerURL + "' ";
          }
          htmlSliders += "/>";
          htmlSliders += "</div>";

          pager +=
            "<a href='#'><img src='" +
            getViews[j] +
            "' width='40' height='40' /></a>";
        }

        if (hasVideo) {
          htmlSliders += "<div class='media-slide media-slide-video'>";
          htmlSliders +=
            "<div class='media-video-wrap' data-video-ref='" + videoRef + "'>";
          htmlSliders +=
            "<img width='" +
            iWidth +
            "' height='" +
            iHeight +
            "' src='data:image/gif;base64,R0lGODlhAQABAAAAACH5BAEKAAEALAAAAAABAAEAAAICTAEAOw==' />";
          htmlSliders += "</div>";
          htmlSliders += "</div>";
          pager +=
            "<a href='#'><img src='" +
            theme.videoImg +
            "' class='videoSlide' /></a>";
        }

        if (htmlSliders != "") {
          var elem = $(this).find(".product-image-slideshow");
          var elemParent = elem.parent();

          if (elem.find(".cycle-slide").length > 0) {
            elem.cycle("destroy");
            elem.remove();
            if (document.body.classList.contains("template-product")) {
              elemParent.prepend(
                '<div class="product-image-slideshow" data-allow-wrap="false" data-cycle-swipe="true" data-cycle-slides="> div.media-slide" data-cycle-fx="scrollHorz" data-cycle-log="false" data-cycle-timeout="0" data-cycle-carousel-visible="1"  data-cycle-next="~ .image-navigation .next" data-cycle-prev="~ .image-navigation .prev" data-cycle-pager="#cusPager"  data-cycle-pager-template="">' +
                  '<img loading="lazy" src="data:image/gif;base64,R0lGODlhAQABAAAAACH5BAEKAAEALAAAAAABAAEAAAICTAEAOw==" border="0"  width="' +
                  iWidth +
                  '" height="' +
                  iHeight +
                  '" /></div>'
              );
              elem = $(this).find(".product-image-slideshow");
              elem.html(htmlSliders);
              var elem1 = $("#cusPager");
              elem1.html(pager);
            } else {
              elemParent.prepend(
                '<div class="product-image-slideshow" data-allow-wrap="false" data-cycle-swipe="true" data-cycle-slides="> div.media-slide" data-cycle-fx="scrollHorz" data-cycle-log="false" data-cycle-timeout="0" data-cycle-carousel-visible="1"  data-cycle-next="~ .image-navigation .next" data-cycle-prev="~ .image-navigation .prev" data-cycle-pager="#cusPager"  data-cycle-pager-template="">' +
                  '<img loading="lazy" src="data:image/gif;base64,R0lGODlhAQABAAAAACH5BAEKAAEALAAAAAABAAEAAAICTAEAOw==" border="0"  width="' +
                  iWidth +
                  '" height="' +
                  iHeight +
                  '" /></div>'
              );
              elem = $(this).find(".product-image-slideshow");
              elem.html(htmlSliders);
            }
          } else {
            elem.html(htmlSliders);
            if (document.body.classList.contains("template-product")) {
              var elem1 = $("#cusPager");
              elem1.html(pager);
            }
          }

          //need to be defined before calling cycle();
          elem.on("cycle-post-initialize", function (event, opts) {
            if (elemParent.parent().hasClass("main")) {
              if (elem.find(".cycle-slide-active img.nszoomer").length > 0) {
                (async () => {
                  const { checkLibrary } = await import(
                    theme.components.commonURL
                  );

                  checkLibrary(
                    $.Zoomer,
                    theme.components.zoomLibraryURL,
                    function () {
                      models.activateZoom(
                        elem.find(".cycle-slide-active img.nszoomer")
                      );
                    }
                  );
                })();
              }
            }
          });

          elem.cycle();

          elem.on("cycle-pager-activated", function (event, opts) {
            models.loadMedia(elem, event, opts);
          });

          elem.on("cycle-next", function (event, opts) {
            models.loadMedia(elem, event, opts);
          });
          elem.on("cycle-prev", function (event, opts) {
            models.loadMedia(elem, event, opts);
          });
        }
      }
    });
  },
  activateZoom: function (imgElem) {
    if (models.instMainProductZoom !== null) {
      models.instMainProductZoom = null;
    }

    models.instMainProductZoom = new $.Zoomer({
      element: imgElem,
      zoomwidth: $(".product-media.main").attr("data-zwidth"),
      zoomheight: $(".product-media.main").attr("data-zheight"),
      usetouch: !$("#viewport").is(":visible") ? true : false,
      ontouch: function (elem) {
        $(elem).off("click");
        $(elem).on("click", function () {
          models.showMobileViewer($(this));
        });
      },
      onzoom: function () {},
    });
  },
  showMobileViewer: function (elem) {
    var zoomimage = elem.attr("big");
    $(document.body).addClass("mobilezoomactive");
    if ($("#mobileimageviewer").length <= 0) {
      $(document.body).append(
        "<div class='mobile' id='taptozoomout'>" +
          '<div class="hover-msg hide">' +
          '<div class="hover-wrap mobile">' +
          '<span class="img">' +
          '<span class="mobile">' +
          '<span class="fa fa-search-minus"></span>' +
          " Tap on the image to zoom out" +
          "</span>" +
          "</span></div></div>" +
          "</div>" +
          "<div id='mobileimageviewer'><div class='wrap'><a id='closemobileviewer' href='javascript:void(0);'><img src='" +
          zoomimage +
          "'/></a></div></div>"
      );
    } else {
      $("#mobileimageviewer .wrap img").attr("src", zoomimage);
    }

    $("#mobileimageviewer").width($(window).width() + "px");
    $("#mobileimageviewer").height($(window).height() + "px");
    $("#mobileimageviewer .wrap").scrollLeft(
      ($("#mobileimageviewer .wrap")[0].scrollWidth - $(window).width()) / 2
    );
    $(window).resize(function () {
      $("#mobileimageviewer").width($(window).width() + "px");
      $("#mobileimageviewer").height($(window).height() + "px");
    });
  },
  closeMobileViewer: function () {
    $(document.body).removeClass("mobilezoomactive");
    $("#mobileimageviewer").remove();
    $("#taptozoomout").remove();
    $("body,html").scrollTop(0);
  },
  loadMedia: function (elem, event, opts) {
    //Load Image
    var getImgAttrib = elem.find(".cycle-slide-active img").attr("data-src");
    var getVideoAttrib = null;
    if (elem.find(".cycle-slide-active .media-video-wrap").length > 0) {
      getVideoAttrib = elem
        .find(".cycle-slide-active .media-video-wrap")
        .attr("data-video-ref");
    }

    if (typeof getImgAttrib !== "undefined") {
      elem.find(".cycle-slide-active img").attr("src", getImgAttrib);
      elem.find(".cycle-slide-active img").removeAttr("data-src");
    }

    if (elem.find(".cycle-slide-active .nszoomer").length > 0) {
      if (elem.find(".zoomer-wrapper").length > 0) {
        elem.find(".zoomer-wrapper .nszoomer").removeClass("imageready");
        elem
          .find(".zoomer-wrapper")
          .before(elem.find(".zoomer-wrapper .nszoomer"));
        elem.find(".zoomer-wrapper").remove();
      }
      models.activateZoom(elem.find(".cycle-slide-active img.nszoomer"));
    }

    //Load Video
    if (getVideoAttrib !== null) {
      var videoSrc = getVideoAttrib.match(
        "/http://(?:www.)?(?:(vimeo).com/(.*)|(youtube).com/watch?v=(.*?)&)/"
      );
      if (videoSrc == "vimeo") {
        if (
          elem.find(".cycle-slide-active .media-video-wrap .vimeo-space")
            .length <= 0
        ) {
          $.ajax({
            type: "GET",
            url:
              "https://vimeo.com/api/oembed.json?url=" +
              encodeURI(getVideoAttrib),
            success: function (response) {
              if (response.thumbnail_url !== "") {
                var initialThumbURL = response.thumbnail_url.split("_")[0];

                var newThumbURL = initialThumbURL + "_86x96";

                //$(productPageInstance.productContainer + " .product-image-thumbnails li.video a").html("<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 512 512'><g><path class='fa-secondary' fill='currentColor' d='M256 8C119 8 8 119 8 256s111 248 248 248 248-111 248-248S393 8 256 8zm115.7 272l-176 101c-15.8 8.8-35.7-2.5-35.7-21V152c0-18.4 19.8-29.8 35.7-21l176 107c16.4 9.2 16.4 32.9 0 42z' opacity='0.4'></path><path class='fa-primary' fill='currentColor' d='M371.7 280l-176 101c-15.8 8.8-35.7-2.5-35.7-21V152c0-18.4 19.8-29.8 35.7-21l176 107c16.4 9.2 16.4 32.9 0 42z'></path></g></svg><img alt=" +  response.title + " src='" + newThumbURL + "'>")
                var appid = "122963";
                var htmlVideo = "";
                htmlVideo +=
                  '<div class="vimeo-space"><iframe width="100%" height="100%" src="https://player.vimeo.com/video/' +
                  response.video_id +
                  "?autoplay=0&loop=1&badge=0&autopause=0&player_id=0&app_id=" +
                  appid +
                  '" allow="fullscreen;" frameborder="0" webkitallowfullscreen mozallowfullscreen allowfullscreen></iframe></div><script src="https://player.vimeo.com/api/player.js"></script>';

                elem
                  .find(".cycle-slide-active .media-video-wrap")
                  .html(htmlVideo);
              }
            },
            error: function (status) {
              console.warn("ERROR", status);
            },
          });
        }
      } else {
        var htmlVideo = "";
        var videoId = models.YouTubeGetID(getVideoAttrib);
        console.log(getVideoAttrib + " " + videoId);
        htmlVideo +=
          '<div class="you-space"><iframe  width="590" height="500" id="video-youtube" src="https://www.youtube.com/embed/' +
          videoId +
          '" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" allowfullscreen></iframe></div><script src="https://www.youtube.com/iframe_api"></script>';
        //htmlVideo += '<iframe width="560" height="315" src="https://www.youtube.com/embed/FjknHfig6Q0?si=0ETsfspCCOwNqCxc" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" allowfullscreen></iframe>';
        elem.find(".cycle-slide-active .media-video-wrap").html(htmlVideo);
      }
    } else {
      //stop Video
      if (elem.find(".vimeo-space iframe").length > 0) {
        elem
          .find(".vimeo-space iframe")
          .attr("src", elem.find(".vimeo-space iframe").attr("src"));
      }
    }
  },
  YouTubeGetID: function (url) {
    var ID = "";
    url = url
      .replace(/(>|<)/gi, "")
      .split(/(vi\/|v=|\/v\/|youtu\.be\/|\/embed\/)/);
    if (url[2] !== undefined) {
      ID = url[2].split(/[^0-9a-z_\-]/i);
      ID = ID[0];
    } else {
      ID = url;
    }
    return ID;
  },

  setSelectedModel: function () {
    var getModelId = models.getModel();
    $(".model-viewer-selection a.model").removeClass("sel");

    $(".model-viewer-selection a.model").each(function () {
      if ($(this).attr("data-model-id") == getModelId) {
        $(this).addClass("sel");
        return false;
      }
    });
  },
  getModelInfo: function (info) {
    var retValObj = {
      type: "",
      description: "",
      position: "",
      name: "",
      id: "",
    };
    var getModelId = models.getModel();
    $(".model-viewer-selection a.model").each(function () {
      if ($(this).attr("data-model-id") == getModelId) {
        retValObj = {
          type: $(this).attr("data-model-type"),
          description: $(this).attr("data-model-description"),
          position: $(this).attr("data-model-position"),
          name: $(this).attr("data-model-name"),
          id: $(this).attr("data-model-id"),
        };
        return false;
      }
    });
    return retValObj;
  },
  saveModel: function (modelId) {
    Cookies.set("modelSelection", modelId, 365);
  },
  getModel: function () {
    return typeof Cookies.get("modelSelection") !== "undefined"
      ? Cookies.get("modelSelection")
      : "0";
  },
  getModelView: function () {
    return typeof Cookies.get("modelView") !== "undefined"
      ? Cookies.get("modelView")
      : "0";
  },
  saveModelView: function (onoff) {
    //"0" or 1
    Cookies.set("modelView", onoff, 365);
  },
};

export default models;
